import { AnimatePresence } from "framer-motion";
import { lazy, Suspense } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import AppFooter from "./components/shared/AppFooter";
import AppHeader from "./components/shared/AppHeader";
import "./css/App.css";
import UseScrollToTop from "./hooks/useScrollToTop";
import useThemeSwitcher from "./hooks/useThemeSwitcher";

const About = lazy(() => import("./pages/AboutMe"));
const Contact = lazy(() => import("./pages/Contact.jsx"));
const Home = lazy(() => import("./pages/Home"));
const Projects = lazy(() => import("./pages/Projects"));
const Skills = lazy(() => import("./pages/Skills"));
const ProjectSingle = lazy(() => import("./pages/ProjectSingle.jsx"));

function App() {
  const [activeTheme, setTheme] = useThemeSwitcher();

  return (
    <AnimatePresence>
      <div className=" bg-secondary-light dark:bg-primary-dark transition duration-300">
        <Router>
          <ScrollToTop />
          <AppHeader activeTheme={activeTheme} setTheme={setTheme} />
          <Suspense fallback={""}>
            <Routes>
              <Route
                path="/"
                element={<Home activeTheme={activeTheme} setTheme={setTheme} />}
              />
              <Route path="projects" element={<Projects />} />
              <Route
                path="projects/single-project/:name"
                element={<ProjectSingle activeTheme={activeTheme} />}
              />

              <Route path="skills" element={<Skills />} />
              <Route path="about" element={<About />} />
              <Route path="contact" element={<Contact />} />
            </Routes>
          </Suspense>
          <AppFooter />
        </Router>
        <UseScrollToTop />
      </div>
    </AnimatePresence>
  );
}

export default App;
